module.exports = __webpack_public_path__ + "img/linkedin-curious.0ed92e5e.png";